import { ContentType, Page, Template, Translation } from './types';

export const getContentPath = (contentData: ContentType) => {
  const contentTypePath = `/${contentData.type}`;
  const filenamePath = `/${contentData.filename}`;
  switch (contentData.type) {
    case 'translations': {
      const defaultVersion = 'v1';
      const version = (contentData as Translation).version
        ? contentData.version
        : defaultVersion;
      const versionPath = `/${version}`;
      const languagePath = `/${(contentData as Translation).language}`;

      return contentTypePath + versionPath + languagePath + filenamePath;
    }
    case 'templates': {
      const domainsPath = '/domains';
      const hostPath = `/${(contentData as Template).host.replaceAll(
        '.',
        '-',
      )}`;

      return domainsPath + hostPath + filenamePath;
    }
    case 'pages': {
      const defaultPageVersion = 'v1';
      const pageVersion = (contentData as Page).version
        ? contentData.version
        : defaultPageVersion;
      const pageVersionPath = `/${pageVersion}`;
      const pagelanguagePath = `/${(contentData as Page).language}`;
      return (
        contentTypePath + pageVersionPath + pagelanguagePath + filenamePath
      );
    }
    case 'CSS': {
      const cssPath = '/consent-manager';
      return cssPath + filenamePath;
    }
    default:
      return contentTypePath + filenamePath;
  }
};
